// Material UI
import { Button, Grid, Paper, Typography, Box } from "@mui/material";
import FilterListIcon from '@mui/icons-material/FilterList';

// Components
import Dropdown from "../../../components/inputs/dropdown";

import WrapperDatePicker from '../../../components/wrapperDatapicker';

// Hooks
import useCashRegisters from "../../../hooks/cashRegisters/useCashRegisters";

const ArchingFilters = ({ filters, setFilters, clearFilters }) => {
    const { cashRegisters } = useCashRegisters();
    const onFilterChange = (event) =>
        setFilters({
            ...filters,
            [event.target.name]: event.target.value,
            pageNumber: 1
        });

    return (
        <Box component={Paper} padding={2}>
            <Grid container spacing={1}>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 2
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Seleccionar caja: </Typography>
                        </Grid>
                        <Grid size={12}>
                            <Dropdown
                                fullWidth
                                name='cashRegisterId'
                                label='Caja'
                                onChange={onFilterChange}
                                size='small'
                                getOptionLabel={(option) => option?.name}
                                getOptionValue={(option) => option?.id}
                                values={cashRegisters}
                                value={filters?.cashRegisterId || ''}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 4
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary' style={{ display: 'block' }}> Filtrar por fecha: </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 6
                            }}
                        >


                            <WrapperDatePicker
                                filters={filters?.from}
                                handleFilterChange={onFilterChange}
                                type="from"
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 6
                            }}
                        >

                            <WrapperDatePicker
                                filters={filters?.to}
                                handleFilterChange={onFilterChange}
                                type="to"
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Box component={Grid} item display='flex' flexGrow={1} justifyContent='flex-end' alignItems='flex-end'>
                    <Button
                        color="primary"
                        variant="outlined"
                        onClick={clearFilters}
                        startIcon={<FilterListIcon />}
                    >
                        Limpiar
                    </Button>
                </Box>
            </Grid>
        </Box>
    );
}

export default ArchingFilters;